import createAtom from "tiny-atom";
import createRouter from "space-router";

export function moonwave(options = {}) {
  options.atom = options.atom || {};
  options.router = options.router || {};

  const app = {
    options: options,

    state: initialState => {
      options.atom.initialState = initialState;
      return app;
    },

    routes: (routes, onTransition) => {
      options.router.routes = routes;
      options.router.onTransition = onTransition;
      return app;
    },

    actions: actions => {
      options.atom.actions = actions;
      return app;
    },

    install: (render, unrender) => {
      options.render = render;
      options.unrender = unrender;
      return app;
    },

    render: (App, root) => {
      options.root = root;
      run(App, app);
      return app;
    },

    unrender: () => {
      stop(app);
      return app;
    },

    assign: attr => {
      Object.assign(app, attr);
      return app;
    }
  };

  return app;
}

const run = (App, app) => {
  const options = app.options;
  options.root = options.root || document.body;
  options.atom.actions = options.atom.actions || {};
  const router = (app.router = createRouter(options.router.routes, options.router));

  app.atom = createAtom(options.atom.initialState, options.atom.actions, options.atom);

  app.atom.fuse(null, {
    navigate(atom, route) {
      router.push(route.pathname || route.path, route);
    },
    navigated({ get, set }, route) {
      set({ prevRoute: get().route, route });
    }
  });

  router.start(route => {
    const preventDefault = options.onTransition && options.onTransition(route);
    if (!preventDefault) {
      app.atom.dispatch("navigated", route);
    }
  });

  app.options.render(App, app);
};

const stop = app => {
  app.router.stop();
  app.options.unrender(app);
};
